/* eslint-disable no-mixed-spaces-and-tabs */
import React, { Component } from 'react';
import { message} from 'antd';
import { isEmpty } from 'lodash';

class CreditCard extends Component {
	fattJs = null;

	constructor(props) {
	  super(props);
	};

	UNSAFE_componentWillMount = () => {
	  const stax_public_apikey = this.props.stax_public_apikey || null;

	  if (stax_public_apikey) {
		const FattJs = window.FattJs;

		const fattJs = new FattJs(stax_public_apikey, {
		number: {
			id: "card-number",
			placeholder: "Card Number",
			style: "width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-number div
		},
		cvv: {
			id: "card-cvv",
		//   disabled = {this.props.credit_card_check === false},
			placeholder: "CVV",
			style: "width: 100%; font-size: 15px; font-family: Helvetica Neue, Helvetica; color: #31325f; font-weight: 300;" // 35px is the height of my card-cvv div
		}
		});

		fattJs.showCardForm().then(handler => {
			console.log('form loaded', handler);
		}).catch(err => {
			console.error('error occur', err);
		});

		this.fattJs = fattJs;
	    this.props.setFattJs(fattJs);

	  } else {
		message.error('Error occur while loading stax. please contact to admin.', 10);
	  }
	}

	// Render Credit Card Inputs
	renderCreditCardInputs = () =>
	{
	  const { errors } = this.props;

	  return <div className="credit_card_form" 
	    //   style={{ border: '1px solid #DCDCE6', borderRadius: '8px', marginBottom: '15px' , padding: '8px 19px 18px 10px'}}
	  >
	    <div> 
	      <div
	        id="card-number"
	        placeholder="Card Number"
	        className="form--control item"
	        disabled = {this.props.credit_card_check === false}
	        style={{ height: 50, border: '2px solid #E6E6E6', backgroundColor: '#ffffff' }}
	      ></div>
	      {
	        errors && errors['credit_card_info.card_number'] ? 
	          <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['credit_card_info.card_number']}</label> 
	          : ''
	      }
	    </div>
	    <div className='item special-item'>
	      <div className='half_size_items mm-yyyy'>
	        <div>
	          <input
	            type="text"
	            className="form--control"
	            disabled = {this.props.credit_card_check === false}
	            placeholder="MM"
	            maxLength={2} 
	            inputMode="numeric"
	            onPaste={(event) => {
	              if (event.clipboardData.getData('Text').match(/[^\d]/)) {
	                event.preventDefault();
	              }
	            }}
	            onKeyPress={(e) => {
	              const pattern = /[0-9]/;
	              const inputChar = String.fromCharCode(e.charCode);
	              if (!pattern.test(inputChar)
	              ) {
	                // invalid character, prevent input
	                e.preventDefault();
	              }
	            }}
	            onChange={(e) => { this.props.onCreditCardInfoChange({ card_expiry_month: e.target.value }) }}
	          />
	          {
	            errors && errors['credit_card_info.card_expiry_month'] ?
	              <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['credit_card_info.card_expiry_month']}</label>
	              : ''
	          }
	        </div>

	        <div>
	          <input
	            id="YYYY"
	            name="YYYY"
	            type="text"
	            placeholder="YYYY"
	            className="form--control"
	            maxLength={4} 
	            disabled = {this.props.credit_card_check === false}
	            inputMode="numeric"
	            onPaste={(event) => {
	              if (event.clipboardData.getData('Text').match(/[^\d]/)) {
	                event.preventDefault();
	              }
	            }}
	            onKeyPress={(e) => {
	              const pattern = /[0-9]/;
	              const inputChar = String.fromCharCode(e.charCode);
	              if (!pattern.test(inputChar)
	              ) {
	                // invalid character, prevent input
	                e.preventDefault();
	              }
	            }}
	            onChange={(e) => { this.props.onCreditCardInfoChange({ card_expiry_year: e.target.value }) }}
	          />
	          {
	            errors && errors['credit_card_info.card_expiry_year'] ?
	              <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['credit_card_info.card_expiry_year']}</label>
	              : ''
	          }
	        </div>
	      </div>

	      <div>
	        <div
	          id="card-cvv"
	          className="form--control"
	          style={{ border: '2px solid #E6E6E6', backgroundColor: '#ffffff', height: "55px" }}
	          disabled = {this.props.credit_card_check === false}
	        ></div>
	        {
	          errors && errors['credit_card_info.card_cvv'] ?
	            <label className="new_err_msg"><i className="las la-info-circle"></i> {errors['credit_card_info.card_cvv']}</label>
	            : ''
	        }
	      </div>
	    </div>
	  </div>
	}

	render ()
	{
	  const {checked_permissions} = this.props;

	  return <React.Fragment>
	    {this.renderCreditCardInputs()}
	    <div
	      className="checkbox_wrapper"
	      style={{
	        justifyContent: "flex-start",
    				width: "100%",
    				marginTop: "10px"
	      }}
	    >
	      <input
	        id={'checked_permissions'}
	        type="checkbox"
                  	checked={checked_permissions}
	        style={{marginRight: "15px"}}
                  	onChange={(e) => {
                   	 	this.props.onChangeCheckbox(e.target.checked)
                  	}}
	      />
	      <label htmlFor={checked_permissions}>By selecting this box I grant permission for DoodyCalls to charge my credit card on a monthly basis.</label>
	    </div>
	  </React.Fragment>
	}
}

export default CreditCard;